import { compareDate, compareNumber, compareText } from "./tableSort";

// Column sorters for the agent's own lists (My Listings, My Favorites,
// My Buyers). These lists are loaded whole, so sorting happens in the
// browser with the same rules as the server sorts: text ignores case and
// reads numbers by value, blanks sort first.

const fullName = (person) =>
  [person?.firstName, person?.lastName].filter(Boolean).join(" ");

const listingColumns = (pick) => ({
  address: (a, b) => compareText(pick(a)?.streetAddr, pick(b)?.streetAddr),
  price: (a, b) => compareNumber(pick(a)?.price, pick(b)?.price),
  agent: (a, b) => compareText(fullName(pick(a)?.user), fullName(pick(b)?.user)),
  expiration: (a, b) => compareDate(pick(a)?.expiration, pick(b)?.expiration),
});

/** My Listings: each row is a listing. */
export const listingSorters = listingColumns((row) => row);

/** My Favorites: each row wraps the favorited listing. */
export const favoriteSorters = {
  ...listingColumns((row) => row?.listing),
  createdAt: (a, b) => compareDate(a?.createdAt, b?.createdAt),
};

/** Matches across all of a buyer's search criteria. */
export const totalMatches = (buyer) =>
  (buyer?.buyer_criteria ?? []).reduce(
    (sum, criteria) => sum + (criteria?.criteria_matches?.length || 0),
    0
  );

/** My Buyers: each row is a buyer. */
export const buyerSorters = {
  name: (a, b) => compareText(fullName(a), fullName(b)),
  email: (a, b) => compareText(a?.email, b?.email),
  phone: (a, b) => compareText(a?.phone, b?.phone),
  criteria: (a, b) =>
    compareNumber(a?.buyer_criteria?.length ?? 0, b?.buyer_criteria?.length ?? 0),
  matches: (a, b) => compareNumber(totalMatches(a), totalMatches(b)),
  // Active before deactivated.
  status: (a, b) =>
    compareNumber(a?.isActive === false ? 1 : 0, b?.isActive === false ? 1 : 0),
};
